export { default as Image } from './src/Image'
